var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fusioncharts',{ref:"fc",attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"dataformat":_vm.dataFormat,"dataSource":_vm.dataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }